/* Keep storefront searches limited to product names and tags. Explicit field
   queries also avoid matches in the shared product description. */
(() => {
  const tokens = value => String(value || '').replace(/[():"\\*]/g, ' ').trim().split(/\s+/).filter(Boolean);
  const build = value => tokens(value).map(term => `(title:${term}* OR tag:${term}*)`).join(' AND ');
  const display = query => query.startsWith('(title:')
    ? query.split(' AND ').map(group => group.slice(7).split('* OR tag:')[0]).join(' ')
    : query.replace(/\*/g, '').trim();
  window.AKSearchQuery = {build, display};
  if (/\/search\/?$/.test(location.pathname)) {
    const url = new URL(location.href);
    const query = url.searchParams.get('q') || '';
    if (query && !query.startsWith('(title:')) {
      url.searchParams.set('q', build(query));
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');
      location.replace(url.href);
    }
  }
})();
